import React from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import useQuestionnaireStore from "../store/useQuestionnaireStore";
import useWarning from "../hooks/useWarningModal.js";
import { ChevronLeft } from "lucide-react";
import Button from "../components/common/Button";

const Step5_Onset = () => {
  const navigate = useNavigate();
  const { onset, setOnset, onsetDetail, setOnsetDetail } =
    useQuestionnaireStore();

  // Initialize the warning hook
  const showWarning = useWarning();

  const handleOnsetSelect = (value) => {
    setOnset(value);
    // If switching to gradual, clear the detail selection
    if (value === "gradual") {
      setOnsetDetail(null);
    }
  };

  const handleDetailSelect = (value) => {
    setOnsetDetail(value);
  };

  const handleNext = () => {
    // Validation Logic
    if (!onset) {
      showWarning("Please answer how the pain started to proceed.");

      return;
    }

    // If 'sudden' is selected, a detail MUST be selected
    if (onset === "sudden" && !onsetDetail) {
      showWarning("Please describe how the pain started."); // Shows default message or we could pass a custom one
      return;
    }

    console.log("Onset:", onset, "Detail:", onsetDetail);
    navigate("/step-6"); // Proceed to next step
  };

  return (
    <motion.div
      className="page step5-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="step-header">
        <button onClick={() => navigate(-1)} className="back-button">
          <ChevronLeft size={24} /> Back
        </button>
        <h2>How did the pain start?</h2>
      </div>

      <div className="onset-container">
        {/* Main Question Options */}
        <div className="main-options">
          <button
            className={`option-card ${onset === "sudden" ? "selected" : ""}`}
            onClick={() => handleOnsetSelect("sudden")}
          >
            Appears suddenly
          </button>
          <button
            className={`option-card ${onset === "gradual" ? "selected" : ""}`}
            onClick={() => handleOnsetSelect("gradual")}
          >
            Slowly over days or weeks
          </button>
        </div>

        {/* Sub-question: Only visible if 'sudden' is selected */}
        <AnimatePresence>
          {onset === "sudden" && (
            <motion.div
              className="sub-options-container"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <h4>Describe how it started:</h4>
              <div className="sub-options-grid">
                {["During activity", "Trauma", "On waking up"].map((detail) => (
                  <button
                    key={detail}
                    className={`sub-option-btn ${
                      onsetDetail === detail ? "selected" : ""
                    }`}
                    onClick={() => handleDetailSelect(detail)}
                  >
                    {detail}
                  </button>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <div className="navigation-buttons">
        <Button onClick={handleNext}>Next</Button>
      </div>

      
    </motion.div>
  );
};

export default Step5_Onset;
